import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useMachines } from '../context/MachineContext';
import MachineCard from '../components/MachineCard';
import styles from './StockPage.module.css';

export default function StockPage() {
  const { machines, categories } = useMachines();
  const [searchParams, setSearchParams] = useSearchParams();

  const [search, setSearch]     = useState('');
  const [category, setCategory] = useState(searchParams.get('category') || '');
  const [sort, setSort]         = useState('newest');

  useEffect(() => {
    const cat = searchParams.get('category');
    if (cat) setCategory(cat);
  }, [searchParams]);

  const filtered = machines
    .filter(m => {
      if (search && !m.title.toLowerCase().includes(search.toLowerCase()) &&
          !m.brand.toLowerCase().includes(search.toLowerCase()) &&
          !m.description?.toLowerCase().includes(search.toLowerCase())) return false;
      if (category && m.category !== category) return false;
      return true;
    })
    .sort((a, b) => {
      if (sort === 'newest') return new Date(b.createdAt) - new Date(a.createdAt);
      if (sort === 'oldest') return new Date(a.createdAt) - new Date(b.createdAt);
      return 0;
    });

  const clearFilters = () => {
    setSearch(''); setCategory('');
    setSearchParams({});
  };

  const hasFilters = search || category;

  return (
    <div className={`${styles.page} page-wrapper`}>
      {/* Header */}
      <div className={styles.pageHeader}>
        <div className="container">
          <h1 className={styles.pageTitle}>Machinery Stock</h1>
          <p className={styles.pageSub}>
            {filtered.length} machine{filtered.length !== 1 ? 's' : ''} found
            {hasFilters ? ' matching your filters' : ' in our inventory'}
          </p>
        </div>
      </div>

      <div className="container">
        <div className={styles.layout}>
          {/* ── SIDEBAR FILTERS ───────────────────────────────────── */}
          <aside className={styles.sidebar}>
            <div className={styles.filterCard}>
              <div className={styles.filterHeader}>
                <h3 className={styles.filterTitle}>Filters</h3>
                {hasFilters && (
                  <button className={styles.clearBtn} onClick={clearFilters}>Clear all</button>
                )}
              </div>

              <div className={styles.filterGroup}>
                <label className={styles.filterLabel}>Search</label>
                <input
                  type="text"
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  placeholder="Machine name, brand…"
                  className={styles.filterInput}
                />
              </div>

              <div className={styles.filterGroup}>
                <label className={styles.filterLabel}>Category</label>
                <select value={category} onChange={e => { setCategory(e.target.value); setSearchParams(e.target.value ? { category: e.target.value } : {}); }} className={styles.filterSelect}>
                  <option value="">All Categories</option>
                  {categories.map(c => <option key={c.id} value={c.id}>{c.icon} {c.label}</option>)}
                </select>
              </div>

              <div className={styles.filterGroup}>
                <label className={styles.filterLabel}>Sort By</label>
                <select value={sort} onChange={e => setSort(e.target.value)} className={styles.filterSelect}>
                  <option value="newest">Newest First</option>
                  <option value="oldest">Oldest First</option>
                </select>
              </div>
            </div>
          </aside>

          {/* ── MACHINE GRID ──────────────────────────────────────── */}
          <main className={styles.main}>
            {filtered.length === 0 ? (
              <div className={styles.empty}>
                <div className={styles.emptyIcon}>🔍</div>
                <h3 className={styles.emptyTitle}>No machines found</h3>
                <p className={styles.emptySub}>Try adjusting your filters or clearing the search.</p>
                <button className={styles.emptyBtn} onClick={clearFilters}>Clear Filters</button>
              </div>
            ) : (
              <div className={styles.grid}>
                {filtered.map(m => <MachineCard key={m.id} machine={m} />)}
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
}
